import React from "react";
import { motion } from "framer-motion";
import { FiShield, FiCheckCircle, FiTrendingUp, FiUsers } from "react-icons/fi";
import "./AboutStory.css";
import useSiteSettings from '../../hooks/useSiteSettings';

const iconList = [<FiShield />, <FiCheckCircle />, <FiTrendingUp />, <FiUsers />];

export default function AboutStory() {
  const { settings } = useSiteSettings();
  const values = settings.aboutValues || [];
  const timeline = settings.aboutTimeline || [];
  return (
    <section className="abs">
      <div className="container">
        <div className="abs__grid">
          <motion.div className="abs__left" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.22 }} transition={{ duration: 0.5, ease: "easeOut" }}>
            <div className="abs__kicker">{settings.aboutStoryKicker || 'About Us'}</div>
            <h2 className="abs__title">{settings.aboutStoryTitle}</h2>
            <p className="abs__text">{settings.aboutStoryTextOne}</p>
            <p className="abs__text">{settings.aboutStoryTextTwo}</p>
            <div className="abs__highlight"><div className="abs__hlTitle">{settings.aboutHighlightTitle}</div><div className="abs__hlText">{settings.aboutHighlightText}</div></div>
          </motion.div>
          <motion.div className="abs__right" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.22 }} transition={{ duration: 0.5, ease: "easeOut", delay: 0.05 }}>
            <div className="abs__values">{values.map((v, i) => <div className="abs__valueCard" key={`${v.title}-${i}`}><div className="abs__valueIcon">{iconList[i % iconList.length]}</div><div className="abs__valueTitle">{v.title}</div><div className="abs__valueText">{v.text}</div></div>)}</div>
          </motion.div>
        </div>
        <motion.div className="abs__timelineWrap" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.5, ease: "easeOut" }}>
          <div className="abs__timelineHead"><div className="abs__timelineTitle">Our Journey</div><div className="abs__timelineSub">A quick timeline of how we grew and where we are now.</div></div>
          <div className="abs__steps">{timeline.map((t, i) => <div className="abs__step" key={`${t.year}-${i}`}><div className="abs__stepTop"><div className="abs__year">{t.year}</div><div className="abs__dot" />{i !== timeline.length - 1 && <div className="abs__line" />}</div><div className="abs__stepBody"><div className="abs__stepTitle">{t.title}</div><div className="abs__stepDesc">{t.desc}</div></div></div>)}</div>
        </motion.div>
      </div>
    </section>
  );
}
